import { useState } from "react";
import { TabStyle } from "../../../TabsStyle/TabsStyle";
import StyleFillModal from "./StyleFillModal";
import StyleConfig from "./StyleConfig";
import checklistStyle, { modeloStyleType } from "../../../../service/checklistStyle";
import { trackEventMatomo } from "../../../../helpers/matomo";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import AttToken from "../../../../helpers/attToken";
import { useTranslation } from "react-i18next";
import queryClient from "../../../../service/query";
import { initialObjectToSend } from "../../ChecklistStyle";

type props = {
  editing: boolean,
  setEditing: Function,
  openModal: boolean,
  setOpenModal: Function,
  setObjectToEdit: Function,
  objectToEdit: modeloStyleType,
}

const modelService = new checklistStyle()

export default function EditFormDeslogadoTabs({
  editing,
  setEditing,
  openModal,
  setOpenModal,
  objectToEdit,
  setObjectToEdit
}: props) {

  const mapNames = {
    style: 'Editar visual',
    config: 'Editar configurações'
  }

  const { t } = useTranslation('translation');

  const [isTab, setIsTab] = useState({
    isActiveObject: 'style',
    object: [
      'style',
      'config'
    ]
  });

  const toggleClass = (index: number) => {
    setIsTab({ ...isTab, isActiveObject: isTab.object[index] })
    trackEventMatomo('Configurar impressões form deslogado', 'click', 'tab', 'troca de abas')
  }

  const toggleActive = (index: number) => {
    if (isTab.object[index] === isTab.isActiveObject) {
      return "is-active"
    } else {
      return "inactve"
    }
  }

  const { mutate: edit, isLoading: isLoadingEdit } = useMutation({
    mutationKey: ['EDIT_MODEL'],
    mutationFn: async () => {
      toast.warn(`${t('toast.editingTemplate')}`)
      const token = await AttToken()
      if (token && objectToEdit) {
        const response = await modelService.edit(token, objectToEdit)
        return response
      }
    },
    onSuccess: () => {
      queryClient.resetQueries(['GET_MODELS']);
      toast.success(`${t('toast.templateUpdated')}`);
      setObjectToEdit(initialObjectToSend);
      setOpenModal(false);
      setEditing(false);
    }
  })

  const { mutate: create, isLoading } = useMutation({
    mutationKey: ['CREATE_MODEL'],
    mutationFn: async () => {
      toast.warn(`${t('toast.creatingNewTemplate')}`)
      const token = await AttToken()
      if (token && objectToEdit) {
        const response = await modelService.create(token, objectToEdit)
        return response
      }
    },
    onSuccess: () => {
      queryClient.resetQueries(['GET_MODELS'])
      toast.success(`${t('toast.templateCreatedSuccess')}`)
      setObjectToEdit(initialObjectToSend)
      setOpenModal(false);
    }
  })

  return (
    <div className={openModal ? "modal is-active" : "modal"}>
      <div className="modal-background"></div>
      <div className="modal-card" >
        <header className="modal-card-head">
          <p className="modal-card-title" style={{ textAlign: 'center' }}>Criar layout para formulário web</p>
        </header>
        <div className="modal-card-body" style={{ padding: 0, paddingTop: 10 }}>
          <div style={{ width: '100%' }}>
            <div className="tabs is-boxed" style={{ padding: 0, paddingLeft: 10 }}>
              <ul>
                {isTab.object.map((el, index) => (
                  <li key={index} className={toggleActive(index)} onClick={() => { toggleClass(index) }}>
                    <TabStyle theme={toggleActive(index)}>{mapNames[el as keyof typeof mapNames]}</TabStyle>
                  </li>
                ))}
              </ul>
            </div>
            {isTab.isActiveObject === 'style' && (
              <StyleFillModal
                setObjectToEdit={setObjectToEdit}
                objectToEdit={objectToEdit}
              />
            )}
            {isTab.isActiveObject === 'config' && (
              <StyleConfig
                setObjectToEdit={setObjectToEdit}
                objectToEdit={objectToEdit}
              />
            )}
          </div>
        </div>
        <footer className="modal-card-foot">
          <button
            className="button is-success is-small"
            onClick={!editing ? () => {
              create()
              trackEventMatomo('Configurar impressões form deslogado', 'click', 'button', 'salva')
            } : () => {
              edit()
              trackEventMatomo('Configurar impressões form deslogado', 'click', 'button', 'salva')
            }}
          disabled={isLoading || isLoadingEdit || !objectToEdit.associatedChecklists?.length}
          >
            {t('checklists.save')}
          </button>
          <button className="button is-small"
            disabled={isLoading || isLoadingEdit}
            onClick={() => {
              setObjectToEdit(initialObjectToSend)
              setOpenModal(false);
              setEditing(false);
              trackEventMatomo('Configurar impressões form deslogado', 'click', 'button', 'cancela')
            }}>{t('checklists.cancel')}
          </button>
        </footer>
      </div>
    </div>
  )
}


